import { FaAngleLeft, FaAngleRight , FaAngleDoubleLeft , FaAngleDoubleRight  } from "react-icons/fa";

import "./paginationComp.scss";

function PaginationComp({ currentPage , totalPages , handleGetData }) {

//===Event handler start here===

const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
        handleGetData(page);
    }
  };
  
  
  const renderPageNumbers = () => {
    const pageNumbers = [];
    const startPage = Math.max(1, currentPage - 2);
    const endPage = Math.min(totalPages, currentPage + 2);

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <button
          key={i}
          onClick={() => handlePageChange(i)}
          className={currentPage === i ? 'buttonNum_pagination active' : 'buttonNum_pagination'}
        >
          {i}
        </button>
      );
    }
    
      return pageNumbers;
  };
  
//===Event handler end here===
  return (
        <div className="pagination">
          {
            ( totalPages === 1 ) 
            ?
            ( <></> )
            :
            ( <>
              {
               ( totalPages > 3 ) &&
               ( 
                <button className="buttonNum_pagination_arrow arrow_on_the_leftEdge" onClick={() => handlePageChange(1)} disabled={currentPage === 1}>
                 <FaAngleDoubleLeft  className={currentPage ===  1 ? 'arrow_disabled_Icon' : ''}  />
               </button> )
              }

              
              <button className="buttonNum_pagination_arrow" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
               <FaAngleLeft  className={currentPage ===  1 ? 'arrow_disabled_Icon' : ''}  />
              </button>
              
               {renderPageNumbers()}
                          
              <button className={"buttonNum_pagination_arrow"} onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
               <FaAngleRight  className={currentPage === totalPages ? 'arrow_disabled_Icon' : ''} />
              </button>
              
              {
                ( totalPages > 3 ) &&
                (
                <button className={"buttonNum_pagination_arrow arrow_on_the_rightEdge"} onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages}>
                  <FaAngleDoubleRight   className={currentPage === totalPages ? 'arrow_disabled_Icon' : ''} />
                </button>
                )
              }
              
              </> )
          }

        </div>
  )
}

export default PaginationComp;